import React from 'react';
import { FadeIn } from './Shared';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  location: string;
}
const TestimonialCard = ({
  quote,
  author,
  location
}: TestimonialProps) => <div className="bg-navy-800/50 p-8 rounded-2xl border border-navy-700 relative h-full flex flex-col" data-id="element-337">
    <Quote className="absolute top-6 right-6 w-8 h-8 text-navy-600 opacity-50" data-id="element-338" />
    <div className="text-gold-400 mb-4 text-sm" data-id="element-339">⭐⭐⭐⭐⭐</div>
    <p className="text-lg text-gray-100 italic mb-6 relative z-10 flex-grow" data-id="element-340">
      "{quote}"
    </p>
    <div data-id="element-341">
      <div className="font-bold text-white" data-id="element-342">{author}</div>
      <div className="text-sm text-gray-300" data-id="element-343">{location}</div>
    </div>
  </div>;
export const Testimonials = () => {
  return <section className="py-8 md:py-12 px-4" data-id="element-344">
      <div className="max-w-5xl mx-auto" data-id="element-345">
        <FadeIn data-id="element-346">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-347">
            <TestimonialCard quote="La primera semana bajó la intensidad de los berrinches a la mitad. El Protocolo de los 90 Segundos funciona de verdad." author="Mariana G." location="Córdoba" data-id="element-348" />
            <TestimonialCard quote="Por fin entendí por qué mi hijo explotaba siempre a las 5 de la tarde. El Tomo 3 me lo explicó todo." author="Laura P." location="Rosario · Mamá de mellizos" data-id="element-349" />
            <TestimonialCard quote="Pensé que era el problema yo. El Tomo 1 me cambió la cabeza. Ahora reacciono diferente." author="Roberto M." location="Buenos Aires" data-id="element-350" />
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const MoreTestimonials = () => {
  return <section className="py-8 md:py-12 px-4 bg-navy-800/30" data-id="element-351">
      <div className="max-w-5xl mx-auto" data-id="element-352">
        <FadeIn data-id="element-353">
          <h2 className="text-xl md:text-3xl font-serif font-bold text-center text-white mb-8" data-id="element-354">
            <span className="text-red-500 mr-2" data-id="element-355">❤️</span> MÁS FAMILIAS QUE YA LO
            TIENEN
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-356">
            <TestimonialCard quote="El Protocolo P.A.U.S.A. me cambió la vida. Antes del MegaPack cada berrinche terminaba con los dos llorando. Ahora tengo un sistema y se nota." author="Cecilia R." location="Mendoza | MegaPack + Método Raíces" data-id="element-357" />
            <TestimonialCard quote="Los berrinches en el supermercado eran mi pesadilla. Después del Bono 3 no volví a ceder un límite por vergüenza. Fue un cambio inmediato." author="Roberto M." location="Buenos Aires | MegaPack Calma Total" data-id="element-358" />
            <TestimonialCard quote="El Método Raíces me hizo entender que estaba elogiando mal a mi hijo. Cambié una sola cosa y en dos semanas su reacción ante los errores fue completamente diferente." author="Sofía C." location="La Plata | MegaPack + Método Raíces" data-id="element-359" />
            <TestimonialCard quote="El Tomo 5 de Reparación me hizo llorar. No sabía que reparar bien podía fortalecer el vínculo más que no fallar nunca. Ese capítulo solo vale todo el precio." author="Pablo A." location="Neuquén | MegaPack Calma Total" data-id="element-360" />
            <TestimonialCard quote="Mi hijo de 4 años empezó a decir 'estoy enojado' en lugar de tirar cosas. En tres semanas. Eso no tiene precio." author="Daniela M." location="Rosario | MegaPack Calma Total" data-id="element-361" />
          </div>
        </FadeIn>
      </div>
    </section>;
};